import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotSellingViewDialogTourConfig: AgTechTourConfig = {
    id: 'lot-selling-view-dialog-tour',
    name: 'Sell Lots Tour',
    steps: [
        {
            targetId: 'lot-selling-update-btn',
            title: 'Update Lots',
            description: 'Jump to the lot update view if you need to correct a lot number, description or other details while selling.',
            position: 'bottom',
        },
        {
            targetId: 'lot-selling-grid',
            title: 'Selling Grid',
            description: 'Each row is an unsold lot in sale order. Enter the winning bidder number and purchase price to record a sale. Use the toolbar to export sold lots, add a lot on the fly or read more help. Invoiced lots are hidden from this grid.',
            position: 'top',
        },
    ]
}
